var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useSelector } from 'react-redux';
import api from 'app/core/api/api.js';
import AssetsSelect from 'app/containers/Assets/AssetsSelect/AssetsSelect.jsx';
import { MUIModal } from 'app/components/Modal';
import { getActionObjectTypeIdentifier, functionsByContentType } from 'app/core/utils/contentTypesUtils';
import { projectConfigDataSelector } from 'app/store/selectors/serverConfig';
const Subscription = (props) => {
    const { title, actionObject, actionTypeId } = props;
    const config = useSelector(projectConfigDataSelector);
    const [usersToSubscribe, setUsersToSubscribe] = useState([]);
    const assetLabel = functionsByContentType[getActionObjectTypeIdentifier(actionTypeId, undefined, config)].labelFeed(actionObject);
    const modalTitle = title || _jsxs("span", { children: ["Register users to ", assetLabel] });
    const save = () => __awaiter(void 0, void 0, void 0, function* () {
        const promises = [];
        if (usersToSubscribe.length) {
            const subscriptionsToCreate = usersToSubscribe.map(({ value }) => {
                return {
                    targetType: actionTypeId,
                    targetId: actionObject.id,
                    user: value,
                    actorOnly: false,
                };
            });
            subscriptionsToCreate.forEach((subscription) => __awaiter(void 0, void 0, void 0, function* () {
                promises.push(api.subscriptions.create(subscription).catch((e) => { }));
            }));
        }
        const response = yield Promise.all(promises);
        return response;
    });
    const onChangeUsersToSubscribe = (value) => {
        setUsersToSubscribe(value);
    };
    return (_jsx(MUIModal, Object.assign({}, props, { title: modalTitle, validateLabel: "Register", onValidate: save, children: _jsx(AssetsSelect, { assetTypes: ['us'], placeholder: "Select users to register", value: usersToSubscribe, onChange: onChangeUsersToSubscribe, multiple: true }) })));
};
export default Subscription;
